// atorhome: fixed-order product gallery.
// Selecting a variant activates its image in place instead of moving it to the front (Dawn default).
// The target image is resolved in snippets/product-media-gallery.liquid (data-variant-media-id),
// which also covers variants without their own image.
(function () {
  customElements.whenDefined('media-gallery').then(() => {
    const MediaGallery = customElements.get('media-gallery');
    const setActiveMedia = MediaGallery.prototype.setActiveMedia;
    if (setActiveMedia.atorhome) return;

    // Dawn passes prepend=true only on variant change; thumbnail clicks pass false.
    MediaGallery.prototype.setActiveMedia = function (mediaId, prepend) {
      if (prepend && this.querySelector(`.is-active[data-media-id="${mediaId}"]`)) return;
      return setActiveMedia.call(this, mediaId, false);
    };
    MediaGallery.prototype.setActiveMedia.atorhome = true;
  });

  if (window.atorhomeGallerySubscribed || typeof subscribe !== 'function') return;
  window.atorhomeGallerySubscribed = true;

  subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
    // Variants with their own image are handled by product-info.js updateMedia().
    if (data.variant?.featured_media) return;

    const mediaId = data.html.querySelector('media-gallery')?.dataset.variantMediaId;
    const productInfo = [...document.querySelectorAll('product-info')].find((el) => el.sectionId === data.sectionId);
    const gallery = productInfo?.querySelector('media-gallery');
    if (!mediaId || !gallery) return;

    const media = gallery.querySelector(`[id^="GalleryViewer"] [data-media-id$="-${mediaId}"]`);
    if (media && !media.classList.contains('is-active')) gallery.setActiveMedia(media.dataset.mediaId, false);
  });
})();
